import { render, staticRenderFns } from "./Detective.vue?vue&type=template&id=313d4bb9&scoped=true&"
import script from "./Detective.vue?vue&type=script&lang=js&"
export * from "./Detective.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=313d4bb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313d4bb9",
  null
  
)

export default component.exports